import axios from "axios";
import { API_BASE_URL } from "../../config";

// Ensure we have a clean base URL without duplicate /api
const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch the Cash Flow report.
 * @param {Object} filters - { start_date, end_date }
 */
export const getCashFlowReport = async (filters = {}) => {
  try {
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    );
    const response = await axios.get(`${BASE}/reports/cash-flow`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching Cash Flow report:", error);
    throw error;
  }
};
